module.exports = __webpack_public_path__ + "img/AI (4).55b36010.png";